// removed by extract-text-webpack-plugin
module.exports = {"root":"credit-history--root--2FQeiMhy","mobile-only":"credit-history--mobile-only--1QQ3wi2h","mobileOnly":"credit-history--mobile-only--1QQ3wi2h","header":"credit-history--header--1QYa_OOl","body":"credit-history--body--2BwHZg00","clickable":"credit-history--clickable--3T2w4K6I"};


//////////////////
// WEBPACK FOOTER
// ./components/credit-history/styles.css
// module id = ./components/credit-history/styles.css
// module chunks = 0